import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { environment } from 'apps/sss/src/environments/environment';
import { Lang, Language } from '../../models/language.model';

export interface LanguageState extends Language {
}

export function createInitialState(): LanguageState {
  return {
    key: environment.defaultLanguage as Lang,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'language' })
export class LanguageStore extends Store<LanguageState> {

  constructor() {
    super(createInitialState());
  }

}
